// @ts-ignore

import { defineNuxtPlugin } from '#app'
import { autoAnimatePlugin } from '@formkit/auto-animate/vue'
export default defineNuxtPlugin((nuxtApp: any) => {
    nuxtApp.vueApp.use(autoAnimatePlugin)
})
